import React, { useEffect, useMemo, useState } from 'react';
import NonlalinService from '../../services/nonlalin/NonlalinService';

const NonlalinMaksudKegiatan = ({id}) => {
    let nonLalinService = useMemo(() => new NonlalinService(), [])
    const [maksudKegiatan, setMaksudKegiatan] = useState('')

    useEffect(() => {
        const getmaksudKegiatan = async () => {
            const response = await nonLalinService.getRefNonlalinMaksudKegiatanById(id)
            setMaksudKegiatan(response.data.urMaksudKegiatan)
        }
        getmaksudKegiatan()
    }, [nonLalinService, id])

    return (
        <>
            {maksudKegiatan}
        </>
    )
}

export default NonlalinMaksudKegiatan